export const contentTableConfig = {
  title: '激活客户记录',
  propList: [
    {prop: 'corpName', label: ' 主体', minWidth: '80'},
    {prop: 'empId', label: '业务员工作账号', minWidth: '80'},
    {prop: 'empName', label: '业务员姓名', minWidth: '80'},
    {prop: 'custUnionid', label: '客户unionId', minWidth: '80'},
    {prop: 'custId', label: '客户ID', minWidth: '80'},
    {prop: 'custName', label: '客户昵称', minWidth: '80'},
    {prop: 'content', label: ' 消息内容/收款总金额', minWidth: '80'},
    {prop: 'dataTime', label: '消息时间/交易时间', minWidth: '80'},
    {prop: 'activateTypeStr', label: '激活类型', minWidth: '80'},
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
